import on from 'dom-event';
import debounce from 'lodash/debounce';
import { isTablet } from 'utils/general';

export default {
  props: {
    mobileId: String,
    desktopId: String,
    autoPlay: {
      type: String,
      default: "enable"
    },
  },
  data: () => ({
    isTablet: isTablet(),
    isPaused: false,
    isMuted: true,
  }),
  mounted() {
    on(window, 'resize', debounce(this.onResize, 300));
    if (this.$refs?.iFrameEl) {
      setTimeout(() => {
        this.video = new Vimeo.Player(this.$refs.iFrameEl);
      }, 100);
    }

    this.isPaused = this.autoPlay == "disable";
  },
  watch: {
    iFrameSrc() {
      setTimeout(() => {
        this.video = new Vimeo.Player(this.$refs.iFrameEl);
      }, 100);
    },
  },
  computed: {
    iFrameSrc() {
      if (this.isTablet) {
        if (this.mobileId) {
          return `https://player.vimeo.com/video/${this.mobileId}?background=1&autoplay=${this.autoPlay == "enable" ? 1 : 0}`;
        }
      } else {
        if (this.desktopId) {
          return `https://player.vimeo.com/video/${this.desktopId}?background=1&autoplay=${this.autoPlay == "enable" ? 1 : 0}`;
        }
      }
      return '';
    },
  },
  methods: {
    onResize() {
      this.isTablet = isTablet();
    },
    handlePauseClick() {
      this.isPaused ? this.video.play() : this.video.pause();
      this.isPaused = !this.isPaused;
    },
    handleSoundClick() {
      this.isMuted = !this.isMuted;
      this.video.setMuted(this.isMuted);
    },
  },
};
